import * as React from 'react';
import { Subscribe, Container } from 'unstated';

interface LayoutState {
  dialog: string | null;
  panelOpen: boolean;
  hasNotifications: boolean;
  pinnedLayers: Record<string, RasterDocument | null>;
}

export class LayoutTools extends Container<LayoutState> {
  state = {
    dialog: null,
    panelOpen: true,
    hasNotifications: false,
    pinnedLayers: {},
  };

  showDialog(dialog: string) {
    this.setState({ dialog });
  }

  showBetaDialog() {
    this.showDialog('beta');
  }

  closeAnyDialog() {
    this.setState({ dialog: null });
  }

  openPanel() {
    this.setState({ panelOpen: true });
  }

  closePanel() {
    this.setState({ panelOpen: false });
  }

  togglePanelOpen() {
    this.setState({ panelOpen: !this.state.panelOpen });
  }

  turnOnNotifications() {
    this.setState({ hasNotifications: true });
  }

  turnOffNotifications() {
    this.setState({ hasNotifications: false });
  }

  pinLayer(fieldId: string, document: RasterDocument) {
    this.setState({
      pinnedLayers: {
        ...this.state.pinnedLayers,
        [fieldId]: document
      }
    });
  }

  unpinLayer(fieldId: string, document: RasterDocument) {
    this.setState({
      pinnedLayers: {
        ...this.state.pinnedLayers,
        [fieldId]: null
      }
    });
  }

  changeLayerBins(fieldId: string, customBins: NdviRasterBins) {
    this.setState({
      pinnedLayers: {
        ...this.state.pinnedLayers,
        [fieldId]: {
          ...this.state.pinnedLayers[fieldId],
          bins: customBins
        }
      }
    });
  }
}

interface Props {
  children: (tools: LayoutTools) => React.ReactNode;
}

const LayoutToolsProvider: React.StatelessComponent<Props> = (props: Props) => {
  return (
    <Subscribe to={[LayoutTools]}>
      {(tools: LayoutTools) => props.children(tools)}
    </Subscribe>
  );
};

export default LayoutToolsProvider;



// WEBPACK FOOTER //
// ./src/providers/LayoutToolsProvider.tsx